module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_m_normal.e290f2ea.png";